export const createHeaders = (customerCode: string) => ({
  'x-partner-code': customerCode,
});
